import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Navigation from './components/Navigation';
import './css/style.css';
import Landing from './components/Landing';
import Ecommerce from './components/Ecommerce';
import Error from './components/Error';
import About from './components/About';
import Work from './components/Work';
import Education from './components/Education';
import Skills from './components/Skills';
import Contact from './components/Contact';

function App() {
  return (
    <React.Fragment>
      <main>
        <Navigation/>
        <Switch>
          <Route exact path="/" component={Work}/>
          <Route path="/landing" component={Landing}/>
          <Route path="/ecommerce" component={Ecommerce}/>
          <Route path="/about" component={About}/>
          <Route path="/education" component={Education}/>
          <Route path="/skills" component={Skills}/>
          <Route path="/contact" component={Contact}/>
          <Route component={Error}/>
        </Switch>
      </main>
      
    </React.Fragment>
  );
}

export default App;
